module.exports = __webpack_public_path__ + "img/switchboard.065da36.svg";